import React, { useState, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import textToSpeech from '../utils/textToSpeech';

const TTSIconButton = memo(({
  text,
  mode = 'generic',
  className = '',
  title = 'Listen',
  ariaLabel = 'Listen'
}) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handleClick = useCallback(() => {
    if (!text) return;

    if (textToSpeech.getIsPlaying()) {
      textToSpeech.stop();
      setIsPlaying(false);
      return;
    }

    const onStart = () => setIsPlaying(true);
    const onEnd = () => setIsPlaying(false);

    if (mode === 'word') {
      textToSpeech.speakWord(text, { onStart, onEnd });
    } else if (mode === 'question') {
      textToSpeech.speakQuestion(text, { onStart, onEnd });
    } else {
      textToSpeech.speak(text, { onStart, onEnd });
    }
  }, [text, mode]);

  return (
    <button
      onClick={handleClick}
      className={className}
      title={isPlaying ? 'Stop' : title}
      aria-label={isPlaying ? 'Stop' : ariaLabel}
    >
      {isPlaying ? '⏹' : '🔊'}
    </button>
  );
});

TTSIconButton.propTypes = {
  text: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['generic', 'word', 'question']),
  className: PropTypes.string,
  title: PropTypes.string,
  ariaLabel: PropTypes.string
};

TTSIconButton.defaultProps = {
  mode: 'generic',
  className: '',
  title: 'Listen',
  ariaLabel: 'Listen'
};

TTSIconButton.displayName = 'TTSIconButton';

export default TTSIconButton;


